import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { CheckCheck, Info, Settings } from 'lucide-react'
import moment from 'moment'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { AuthContext } from '../../context/Auth/AuthContext'
import { getBackendURL } from '../../services/config'
import { useStyles } from './style'

import { ButtonPrimary } from '../../components/ButtonPrimary'

function AnnouncementDialog({
  announcement,
  open,
  handleClose,
  onAnnouncementRead
}) {
  const classes = useStyles()
  const history = useHistory()
  const { user } = useContext(AuthContext)

  const handleCloseAndMarkAsRead = () => {
    onAnnouncementRead(announcement.id)
    handleClose()
  }

  const getMediaPath = filename => {
    return `${getBackendURL()}/public/${filename}`
  }

  // Verificar se o usuário tem permissão para ver o botão
  const hasPermissionForButton = () => {
    if (!announcement.showButtonForRoles) return false
    
    const allowedRoles = announcement.showButtonForRoles.split(',').map(role => role.trim())
    
    // Verificar se o usuário tem uma das roles permitidas
    return allowedRoles.includes(user.profile) || 
           (allowedRoles.includes('super') && user.super) ||
           (allowedRoles.includes('admin') && user.profile === 'admin') ||
           (allowedRoles.includes('conexao') && user.profile === 'conexao')
  }

  const handleRedirectToConnections = () => {
    handleCloseAndMarkAsRead()
    history.push('/connections')
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseAndMarkAsRead}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{announcement.title}</DialogTitle>
      <DialogContent className={classes.content} dividers>
        {announcement.mediaPath && (
          <div
            style={{
              // border: '1px solid #f1f1f1',
              margin: '0 auto 20px',
              textAlign: 'center',
              width: '90%',
              height: 300,
              backgroundImage: `url(${getMediaPath(announcement.mediaPath)})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center'
            }}
          ></div>
        )}
        <DialogContentText id="alert-dialog-description">
          {announcement.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {hasPermissionForButton() && announcement.linkout === '/connections' && (
          <Button
            onClick={handleRedirectToConnections}
            color="primary"
            variant="contained"
            startIcon={<Settings />}
            style={{ marginRight: '8px' }}
          >
            Ir para Conexões
          </Button>
        )}
        <ButtonPrimary
          onClick={handleCloseAndMarkAsRead}
          label={'Marcar como Lido'}
          startIcon={<CheckCheck />}
          autoFocus
        ></ButtonPrimary>
      </DialogActions>
    </Dialog>
  )
}

const AnnouncementsPopover = ({ notifications, onAnnouncementRead }) => {
  const classes = useStyles()
  const theme = useTheme()
  // const { user } = useContext(AuthContext)
  const [announcement, setAnnouncement] = useState({})
  const [showAnnouncementDialog, setShowAnnouncementDialog] = useState(false)

  const handleShowAnnouncementDialog = record => {
    setAnnouncement(record)
    setShowAnnouncementDialog(true)
    // saveAnnouncementToLocalStorage(record.id, user.id)
  }

  // const getMediaPath = filename => {
  //   return `${getBackendURL()}/public/${filename}`
  // }

  const colorPriority = priority => {
    if (priority === 1) return theme.palette.red_100.main
    if (priority === 2) return theme.palette.yellow_400.main
    if (priority === 3) return theme.palette.green_200.main
  }

  const handleCloseDialog = () => {
    setShowAnnouncementDialog(false)
  }


  return (
    <>
      <AnnouncementDialog
        announcement={announcement}
        open={showAnnouncementDialog}
        handleClose={handleCloseDialog}
        onAnnouncementRead={onAnnouncementRead}
      />

      <List
        component="nav"
        aria-label="main mailbox folders"
        className={classes.listAnnoucements}
      >
        {notifications.map((item, key) => (
          <ListItem
            key={key}
            onClick={() => handleShowAnnouncementDialog(item)}
            className={classes.listItemAnnoucements}
          >
            <ListItemText
              primary={
                <span
                  style={{ color: colorPriority(item.priority) }}
                  className={classes.listItemAnnoucementsTitle}
                >
                  <Info style={{ color: colorPriority(item.priority) }} />
                  {item.title}
                </span>
              }
              secondary={
                <div>
                  <span className={classes.listItemAnnoucementsText}>
                    {item.text}
                  </span>
                  <span className={classes.listItemAnnoucementsText}>
                    <a target="_blank" href={item.linkout} rel="noreferrer">
                      {item.linkout}
                    </a>
                  </span>
                  <span className={classes.listItemAnnoucementsDate}>
                    {moment(item.createdAt).format('DD/MM/YYYY')}
                  </span>
                </div>
              }
            />
          </ListItem>
        ))}
      </List>
    </>
  )
}

export default AnnouncementsPopover